var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8997 0.333008H7.09968C2.89967 0.333008 0.333008 2.89967 0.333008 7.09968V16.8997C0.333008 21.0997 2.89967 23.6663 7.09968 23.6663H16.8997C21.0997 23.6663 23.6663 21.0997 23.6663 16.8997V7.09968C23.6663 2.89967 21.0997 0.333008 16.8997 0.333008ZM14.0997 15.4997C14.4497 15.8497 14.4497 16.433 14.0997 16.783C13.983 16.8997 13.7497 17.0163 13.5163 17.0163C13.283 17.0163 13.0497 16.8997 12.933 16.783L8.84968 12.6997C8.49967 12.3497 8.49967 11.7663 8.84968 11.4163L12.933 7.33301C13.283 6.98301 13.8663 6.98301 14.2163 7.33301C14.5663 7.68301 14.5663 8.26634 14.2163 8.61634L10.7163 12.1163L14.0997 15.4997Z",
    fill: "#318BEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackDashboard);
export default __webpack_public_path__ + "static/media/backDashboard.dc9c2738bf9f8517e193a886ec9fad1b.svg";
export { ForwardRef as ReactComponent };